<template>
  <div class="img-view fr">
    <el-image
        :style="{width: width,height: height}"
        :class="{mr20:k!= imgs.length-1}"
        :src="i"
        :key="i"
        :preview-src-list="imgs"
        v-for="(i,k) in imgs"
    >
    </el-image>
  </div>
</template>

<script>
export default {
  name: "imgView",
  props: {
    img: String,
    width: {
      type: String,
      default: "100px"
    },
    height: {
      type: String,
      default: "100px"
    },
  },
  data() {
    return {
      imgs: []
    }
  },
  watch: {
    img(n) {
      this.imgs = this.strToArr(n)
    },
  },
  created() {
    this.imgs = this.strToArr(this.$props.img)
  }
}
</script>

<style scoped lang="scss">
.img-view {

}
</style>


// WEBPACK FOOTER //
// src/components/imgView.vue